<div id="error" fxLayout="column" fxLayoutAlign="center center">
  <div class="content" fxLayout="column" fxLayoutAlign="center center">
    <div class="error-code">{{ 'ERROR.BROWSER.404.TITLE' | translate }}</div>
    <div class="message">{{ 'ERROR.BROWSER.404.DESCRIPTION' | translate }}</div>
    <a class="back-link" [routerLink]="'/login'">
      {{ 'ERROR.BROWSER.REDIRECT' | translate }}</a
    >
  </div>
</div>
